export interface IValidationError {
    subject: ValidationSubject;
}

export enum ValidationSubject {
    ACCOUNTING = 'ACCOUNTING',
    CLASSIFICATION = 'CLASSIFICATION',
    DEMAND = 'DEMAND',
    PURCHASE_REQUISITION = 'PURCHASE_REQUISITION',
}

export interface IExtensionError {
    message: string;
    subject: ValidationSubject;
}

export abstract class ItemExtensionError implements IExtensionError {
    abstract itemId: string;
    abstract subject: ValidationSubject;
    abstract message: string;
}
